module.exports = __webpack_public_path__ + "static/defining-cef9ede88e2fa0f96d6ffb774b4f8b38.svg";